import { render, staticRenderFns } from "./CloneTravelPolicy.vue?vue&type=template&id=71fd24fc&scoped=true&"
import script from "./CloneTravelPolicy.vue?vue&type=script&lang=js&"
export * from "./CloneTravelPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CloneTravelPolicy.vue?vue&type=style&index=0&id=71fd24fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fd24fc",
  null
  
)

export default component.exports